var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgCriminalConduct(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#48A1AF",
    d: "M14.997.006C6.714.006 0 6.72 0 15.003S6.714 30 14.997 30s14.997-6.714 14.997-14.997S23.28.006 14.997.006z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4E4E4E",
    d: "M14.8 7.705c-2.8 0-5.075 1.034-5.12 3.8h.785c.045-2.328 1.968-3.016 4.335-3.016s4.29.688 4.335 3.016h.785c-.045-2.766-2.32-3.8-5.12-3.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CACBCC",
    d: "M27.279 15.909c-.775-2.34-3.824-3.436-6.809-2.447-2.985.989-4.776 3.688-4 6.028.775 2.34 3.823 3.436 6.808 2.447 2.985-.989 4.776-3.688 4.001-6.028zm-4.416 4.776c-2.103.697-4.25-.075-4.797-1.724-.546-1.65.716-3.55 2.82-4.247 2.102-.697 4.25.075 4.796 1.724.546 1.65-.715 3.55-2.819 4.247z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CACBCC",
    d: "M23.226 13.242l-.831-2.508a.89.89 0 0 0-1.126-.566l-3.336 1.106a.89.89 0 0 0-.565 1.125l.83 2.508c.156.468 5.183-1.198 5.028-1.665z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#626262",
    d: "M19.7 12.744a.543.543 0 1 1 .927.18l.02.051c.094.285.05.556-.099.605-.149.05-.346-.142-.44-.426l-.015-.054a.54.54 0 0 1-.394-.356z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4E4E4E",
    d: "M20.565 13.036l-.02-.051a.54.54 0 0 0-.696-.813.543.543 0 0 1 .778.751l.02.052c.094.285.05.556-.099.605h-.003c.081-.105.094-.32.02-.544z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CACBCC",
    d: "M9.524 13.462c-2.985-.99-6.033.106-6.809 2.447-.775 2.34 1.016 5.04 4.001 6.028 2.985.989 6.034-.106 6.809-2.447.775-2.34-1.016-5.04-4-6.028zm2.404 5.5c-.546 1.648-2.694 2.42-4.797 1.723-2.103-.697-3.365-2.598-2.819-4.247.547-1.65 2.694-2.421 4.797-1.724 2.104.697 3.365 2.598 2.82 4.247z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CACBCC",
    d: "M12.061 11.274l-3.335-1.106a.89.89 0 0 0-1.126.566l-.831 2.508c-.155.467 4.872 2.133 5.027 1.665l.83-2.508a.89.89 0 0 0-.565-1.125z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#626262",
    d: "M9.95 12.058a.543.543 0 0 0-.582.865c-.007.018-.015.034-.02.052-.095.285-.05.556.098.605.15.05.346-.142.44-.426l.015-.054a.54.54 0 0 0 .05-1.042z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4E4E4E",
    d: "M9.95 12.058a.543.543 0 0 0-.582.865c-.007.018-.015.034-.02.052-.095.285-.05.556.098.605h.003c-.081-.105-.094-.32-.02-.544l.02-.051a.54.54 0 0 1 .696-.813.538.538 0 0 0-.194-.114z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCriminalConduct);
export default __webpack_public_path__ + "static/media/criminal-conduct.e450f3277a70c519cacaa6c33af405be.svg";
export { ForwardRef as ReactComponent };